module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_steinerberg-24dfd85d0d7b17f7c600989d64505203.png";